import Transformer from '@/transformers/transformer'

export default class supplyTypeTransformer extends Transformer {
  static fetch (supplyType) {
    return {
      id: supplyType.id,
      name: supplyType.name,
      slug: supplyType.slug
    }
  }
}
